/**
 * Tiny build-identifier badge, shown on NON-PROD instances only.
 *
 * Lets you tell at a glance which build/branch is actually live on a review or
 * test box. Renders nothing on production (sundial.heliokode.com) — when the
 * host can't be determined we DEFAULT TO HIDING rather than risk showing it on
 * prod.
 *
 * The build id / MR number are injected at build time (see vite.config.ts).
 */

const PROD_HOST = "sundial.heliokode.com";

function isProdHost(): boolean {
  // Default to "treat as prod" (hide) if anything is off.
  if (typeof window === "undefined" || !window.location) return true;
  return window.location.hostname === PROD_HOST;
}

export function BuildBadge() {
  if (isProdHost()) return null;

  const buildId = typeof __BUILD_ID__ === "string" ? __BUILD_ID__ : "dev";
  const mr = typeof __BUILD_MR__ === "string" ? __BUILD_MR__ : "";

  return (
    <div
      aria-hidden="true"
      style={{
        position: "fixed",
        right: "8px",
        bottom: "8px",
        zIndex: 1,
        pointerEvents: "none",
        padding: "2px 8px",
        borderRadius: "8px",
        background: "var(--card)",
        border: "1px solid var(--border)",
        color: "var(--muted)",
        font: "600 10.5px/1.4 var(--font-head, system-ui)",
        letterSpacing: ".01em",
        opacity: 0.75,
        boxShadow: "0 1px 4px rgba(15,26,48,.12)",
      }}
    >
      build {buildId}
      {mr ? ` · MR !${mr}` : ""}
    </div>
  );
}
